import React from 'react';
import { connect } from 'react-redux';
import store from '../store';
import PropTypes from 'prop-types';
import withRouter from './WithRouter';
import classnames from 'classnames';
import { addOrder, listOrders } from '../actions/order';
import { listClients } from '../actions/client';
import { Button, IconButton, Input, InputGroup, SelectPicker } from 'rsuite';
// import EyeIcon from '@rsuite/icons/legacy/Eye';
// import EyeSlashIcon from '@rsuite/icons/legacy/EyeSlash';
import PlusIcon from '@rsuite/icons/Plus';

class OrderAdd extends React.Component {
  constructor() {
      super();
      this.state = {
        name: '',
        client: '',
        modal: false,
        organizations: [],
        errors: {}
      };
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleClientSelect = this.handleClientSelect.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.showModal = this.showModal.bind(this);
      this.hideModal = this.hideModal.bind(this);
      this.fetchApiClients = this.fetchApiClients.bind(this);
  }

  fetchApiClients() {
    let currentorg = localStorage.getItem('currentorg');
    this.props.listClients(currentorg, 'name', this.props.history);
  }


  componentDidMount() {
    // this.fetchApiClients();
  }

  showModal(event) {
    event.preventDefault();
    this.setState({modal: true});
  };
  hideModal(event) {
    event.preventDefault();
    this.setState({modal: false});
  };

  handleInputChange(n, v ) {
      this.setState({
          [n]: v
      })
  }
  handleClientSelect(v) {
    this.setState({
      'client': v
    })
  }

  handleSubmit(event) {
    event.preventDefault();
    let currentorg = localStorage.getItem('currentorg');
    const order = {
        name: this.state.name,
        organization: currentorg,
        errors: {}
    }
    this.props.addOrder(order, this.props.history);
    this.props.listOrders( currentorg, 'name', this.props.history);
    this.setState({modal: false});
  }

    render() {
      const { errors } = this.state;
      console.log(this.props);
      let clientsList = this.props.clients.list;
      let clientsSel = [];

      for (var i = 0; i < clientsList.length; i++) {
        const l = clientsList[i].name;
        const v = clientsList[i]._id;
        clientsSel.push({ label: l, value: v });
      }
        return (
        <div>
          <div className="button-container" onClick={this.showModal}>
            <IconButton
              appearance="primary"
              className="iron-button add"
              icon={<PlusIcon />}
              >Dodaj zlecenie</IconButton>
          </div>
          <div className={`modal-over add ${this.state.modal === true? 'opened': ''}`}>
            <div className="modal">
              <div className="modal-header">
              <div className="title">
              Dodaj zlecenie
              </div>
              <div className="close-button">
                <button onClick={this.hideModal} id="modal-btn-close" className="on"><span></span><span></span><span></span>
                </button>
              </div>
              </div>
              <form onSubmit={ this.handleSubmit }>
                <div className="form-group">
                    <Input
                    type="text"
                    placeholder="Name"
                    autoComplete="name"
                    className={classnames('form-control form-control-lg', {
                        'is-invalid': errors.name
                    })}
                    name="name"
                    onChange={value => {
                      this.handleInputChange('name', value);
                    }}
                    value={ this.state.name }
                    />
                    {errors.name && (<div className="invalid-feedback">{errors.name}</div>)}
                </div>
                <div className="form-group">
                  <SelectPicker
                    cleanable={false}
                    data={clientsSel}
                    onChange={this.handleClientSelect}
                  />
                </div>
                <div className="form-group">
                    <IconButton
                      appearance="primary"
                      type="submit"
                      className="iron-button"
                      icon={<PlusIcon />}
                      >
                        Dodaj zlecenie
                    </IconButton>
                </div>
              </form>
            </div>
          </div>
        </div>
        );
    }
}

OrderAdd.propTypes = {
    addOrder: PropTypes.func.isRequired,
    listOrders: PropTypes.func.isRequired,
    listClients: PropTypes.func.isRequired
};


const mapStateToProps = state => ({
  orgcurrent: state.orgcurrent,
  clients: state.clients,
  errors: state.errors
});

export default connect(mapStateToProps,{ addOrder, listOrders, listClients })(withRouter(OrderAdd))
